import axios from 'axios'

import { responseErrorInterceptor } from './response-error-interceptor'
import { requestInterceptor } from './request-interceptor'

const interceptor = (): void => {
  // Add a request interceptor
  axios.interceptors.request.use(requestInterceptor, (error) => {
    // Do something with request error
    return Promise.reject(error)
  })

  // Add a response interceptor
  axios.interceptors.response.use((response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  }, responseErrorInterceptor)
}

export { interceptor }
